export default {
  'street_id': 'Улица',
  'building_number': 'Дом'
}
